import React, { useState } from "react";
import "./GreenMachineLineup.css";
import LineupEditor from "../LineupEditor";

import { ReactComponent as ClosedLock } from "../../../../../../../assets/icons/closed-lock.svg";

export default function GreenMachineLineup(props) {
  const [showLineup, setShowLineup] = useState(false);
  const [showEditor, setShowEditor] = useState(false);
  const [locked, setLocked] = useState(props.lineup.locked);

  function toggleLineupShow() {
    setShowLineup(!showLineup);
  }

  function updateLocked(l) {
    setLocked(l);
  }

  function toggleLock() {
    props.commitLock(props.lineup.id, !locked, updateLocked);
  }

  function showLineupEditor() {
    setShowEditor(true);
  }

  function closeLineupEditor(changes) {
    setShowEditor(false);

    if (changes) {
      props.reloadLineups();
    }
  }

  let playerNames = [];

  props.lineup.players.forEach((player) => {
    playerNames.push(player.player.slatePlayer.player.shortenedName);
  });

  return (
    <div
      className={`gm-lineup-container gm-lineup-${
        props.lineup.isValid
          ? "valid"
          : props.lineup.validityLevel > 1
          ? "hard-invalid"
          : "soft-invalid"
      }`}
    >
      {props.lineupNumber ? (
        <div className="gm-lineup-number">Lineup {props.lineupNumber}</div>
      ) : null}
      <div
        className={`gm-lineup-header gm-lineup-header-${
          props.lineup.isValid
            ? "valid"
            : props.lineup.validityLevel > 1
            ? "hard-invalid"
            : "soft-invalid"
        }`}
        onClick={toggleLineupShow}
        onKeyPress={toggleLineupShow}
        role="button"
        tabIndex={0}
      >
        <div className="gm-lineup-summary">
          <div className="gm-lineup-summary-content">
            <div className="gm-lineup-names">{playerNames.join(", ")}</div>
            <div className="gm-lineup-toggle">
              Click To {showLineup ? "Collapse" : "Expand"}
            </div>
          </div>
          {locked ? (
            <div className="gm-lineup-summary-icon">
              <ClosedLock className="gm-lineup-lock-icon" fill="white" />
            </div>
          ) : null}
        </div>
      </div>

      <div
        className={
          "gm-lineup-players " + (showLineup ? "gm-lineup-players-show" : "")
        }
      >
        <table className="gm-lineup-table">
          <thead>
            <td>Pos</td>
            <td>Player</td>
            <td>Salary</td>
          </thead>
          <tbody>
            {props.lineup.players.map((player, index) => {
              const team = player.player.slatePlayer.player.team;

              return (
                <tr key={index} className="gm-lineup-table-row">
                  <td>{player.lineupRosterSlot.rosterSlot.name}</td>
                  <td>
                    {player.player.slatePlayer.player.name}{" "}
                    {team ? `- ${team.abbreviation}` : null}
                    {player.player.slatePlayer.gupPercProj ? (
                      <span>
                        {" "}
                        -{" "}
                        <strong>
                          {player.player.slatePlayer.gupPercProj}%
                        </strong>
                      </span>
                    ) : null}
                    {player.player.slatePlayer.projPoints ? (
                      <span>
                        {" "}
                        -{" "}
                        <strong>{player.player.slatePlayer.projPoints}</strong>
                      </span>
                    ) : null}
                    {player.player.slatePlayer.suffix ? (
                      <> ({player.player.slatePlayer.suffix})</>
                    ) : null}
                  </td>
                  <td>${player.player.slatePlayer.salary}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <p className="gm-lineup-info">
          <p>
            <strong>TOTAL SALARY: ${props.lineup.totalSalary}</strong>
            {props.lineup.totalProjOwnership ? (
              <>
                <br />
                <br />
                <strong>
                  TOTAL OWNERSHIP: {props.lineup.totalProjOwnership}%
                </strong>
              </>
            ) : null}
            {props.lineup.totalProjPoints ? (
              <>
                <br />
                <br />
                <strong>TOTAL POINTS: {props.lineup.totalProjPoints}</strong>
              </>
            ) : null}
          </p>
          <p>
            <button onClick={showLineupEditor}>Edit Lineup</button>
            {"      "}
            <button onClick={toggleLock}>
              {!locked ? "Lock Lineup" : "Unlock Lineup"}
            </button>
          </p>
        </p>
      </div>

      <LineupEditor
        showEditor={showEditor}
        closeEditor={closeLineupEditor}
        lineup={props.lineup}
      />
    </div>
  );
}
